<template>
      <div class="row">
        <div class="col-md-12">

            <div class="clearfix"><br></div>
        </div>
        <div class="col-md-4 mb-2">
            <div class="form-inline">
                <label class="mr-2">Showing</label>
                <select class="form-control" v-model="meta.per_page" @change="loadPerPage">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <label class="ml-2">Entries</label>
            </div>
        </div>
      
        <div class="col-md-4 offset-md-4">
            <div class="form-inline float-right mb-3">
                <label class="mr-2">Search</label>
                <input type="text" class="form-control" @input="search">
            </div>
        </div>

        <div class="col-md-12">
            <CDataTable striped hover bordered :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty>

               <template #firstname="{item}">
                <td v-if="item.firstname">{{item.firstname + ' ' + item.lastname}}</td>
                <td v-else></td>
              </template>
              
              <template #action="{item}">
                <td style='width:450px'>
                  <CButton size="sm" variant="primary" color="info" class="ml-1" @click="edit(item.id)" >Assign Teacher</CButton>
                </td>   
              </template>
            </CDataTable>   
        </div>

        <div class="col-md-6">
            <p>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items</p>
        </div>
      
        <div class="col-md-6">
            <b-pagination
                v-model="meta.current_page"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                align="right"
                @change="changePage"
                aria-controls="dw-datatable"
            ></b-pagination>
        </div>
    
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment';
import service from '@/services/service'

import EventBus from '@/eventBus';

export default {
  name: 'Table',
  props: {
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    itemTemp: {
        type: String
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    items: {
        type: Array,
        required: true
    },
    fields: {
        type: Array,
        required: true
    },
    meta: {
        required: true
    },
    checked: {
        type: Array,
        required: true
    },    
    is_search_by_date: {
        required: true
    },

  },
  data() {
      return {
            form:{
                users:[],
            },
            check1: [],
          sortBy: null, 
          sortDesc: false, 
          deleteModal: false,
          selected: null,
          selectID: null,
          inc: 5,
      }
  },
    watch: {
        sortBy(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        },
        sortDesc(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        }
    },
  created() {
      //this.loadData()
      //this.form.temp = this.vari
      //this.loadChecked()
  },
   methods:{



        loadPerPage(val) {
            this.$emit('per_page', this.meta.per_page)
        },

        loadIsActive(val) {
            this.$emit('is_active', this.meta.is_active)
        },

        changePage(val) {
            this.$emit('pagination', val)
        },

        search: _.debounce(function (e) {
            this.$emit('search', e.target.value)
        }, 500),


        // assign_user: function (id, formdata) {
        //     this.$emit('assign_user', id, formdata)
        // },



        edit: function (id) {
            this.$emit('edit', id)
        },

        assign_permission: function (id) {
            this.$emit('assign_permission', id)
        },
        
        destroy: function (id) {
            this.$emit('destroy', id)
        },    

        frontEndDateFormat: function(date) {
            return moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY');
        },

  }
 
}
</script>
